import {FiltreItems} from "./../vos-filtres/filtre-item";
import {Component, EventEmitter, Input, Output} from "@angular/core";
import {ModalService} from "@digicerba/common";
import * as lodash from "lodash";

@Component({
  selector: 'serveur-resultats-selection-filtres',
  templateUrl: './selection-filtres.component.html'
})
export class ServeurResultatsSelectionFiltresComponent {

  @Input() titre: string
  @Input() filtres: Array<FiltreItems>;

  @Input() filtre: FiltreItems;
    selection: FiltreItems;

  @Output() onRemove = new EventEmitter<FiltreItems>();
  @Output() onSelected = new EventEmitter<FiltreItems>();

  constructor(private modalService: ModalService) {
  }

  ngOnChanges() {
      if (this.filtre && this.filtre.name) {
      if (lodash.find(this.filtres, (filtre) => {
        return filtre.name == this.filtre.name;
      }) == null) {
        this.filtre = null;
        this.onSelected.emit(null);
      }

          this.selection = (this.filtre && this.filtre.name) ? this.filtre : null;
    }
  }

  onFiltreSelected(filtre: FiltreItems) {
    this.onSelected.emit(filtre);
  }

  removeItem() {
    this.modalService.openConfirmDialog("PAGE.SERVEUR-RESULTATS.FILTRE.titreModalSuppression",
      "PAGE.SERVEUR-RESULTATS.FILTRE.suppressionValidation").onDialogClose().subscribe(() => {
        this.onRemove.emit(this.filtre);
      });
  }

  filtreNonVide() {
      return !!(this.filtre && this.filtre.name);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/pages/cerba/pages/serveur-resultats/filtres/selection-filtres/selection-filtres.component.ts